import { Loader2 } from "@/components/icons"

export function AiGeneratingStep() {
  return (
    <div className="flex flex-col items-center justify-center py-12">
      <Loader2 className="text-primary mb-4 size-10 animate-spin" />
      <h3 className="text-lg font-semibold">Generating your use case...</h3>
      <p className="text-muted-foreground mt-1 text-sm">
        AI is analyzing your answers and creating a complete draft.
      </p>
    </div>
  )
}
